import React from "react";

const AchievementCard1Section4 = (props) => {
  return (
    <div className="content m-7 my-20 flex ">
      <div className="icon">
        <img
          className="w-32 lg:w-40"
          src={props.image}
          alt=""
        />
      </div>
      <div className="icon-info mx-6 ">
        <h2 className="cursor-pointer text-2xl font-semibold hover:text-amber-600">
        {props.heading}
        </h2>
        <p className="mb-5 pt-10 text-justify  leading-relaxed text-gray-500">
         {props.para}
        </p>
        {/* <span className="cursor-pointer text-xl font-semibold text-amber-600 hover:text-black">
          Read More{" "}
        </span> */}
      </div>
    </div>
  );
};

export default AchievementCard1Section4;
